export interface IGetNotificationsRequest {
    startDate: Date;
    endDate: Date;
}

export class GetNotificationsRequest implements IGetNotificationsRequest {
    /**
     *
     */
    constructor(start: Date, end: Date) {
        this.startDate = start;
        this.endDate = end;
    }
    public startDate: Date = new Date();
    public endDate: Date  = new Date();
}